export default "__VITE_ASSET__BTXMqFJq__"